import React from 'react';
import classNames from 'classnames';
import Clipboard from 'clipboard';
import { get, extend } from 'lodash';
import { Text } from '@pp-react/text';

import SocialShare from './SocialShare';
import Modal from './Modal';

import styles from './confirmationPage.less';

import * as analytics from '../lib/analytics';

import content from '../lib/i18n';
const i18n = content('shared/components/confirmationPage');

import { ModalInputDiv, InputOverlay, InputOverlayMobileWidth } from './styles';

const ConfirmationPage = ({
  campaignInfo,
  fptiInfo,
  isMobile,
  confirmationDetails,
  pageurl,
}) => {
  new Clipboard('#clipBoardTrigger');

  const clickCopy = event => {
    analytics.trackLink(
      'overlaycopybutton',
      fptiInfo.pgrp,
      fptiInfo.page,
      'link'
    );
  };

  const renderSocialShare = () => {
    let inputOverlayStyle = '';

    if (isMobile) {
      inputOverlayStyle = extend({}, InputOverlay, InputOverlayMobileWidth);
    } else {
      inputOverlayStyle = extend({}, InputOverlay);
    }

    let clipBtnStyle = classNames('clipBtn', {
      clipBtnMobile: isMobile,
    });

    const socialShareNeeded =
      get(campaignInfo, 'templateData.socialShareNeeded', 'yes') === 'yes';
    const confSocialNeeded =
      get(confirmationDetails, 'socialNeeded', 'yes') === 'yes';

    if (socialShareNeeded && confSocialNeeded) {
      return (
        <div style={{ textAlign: 'center' }}>
          <Text
            as='p'
            size='md'
            regular
            className={styles['social-invite-text']}
          >
            {i18n('label.social-invite')}
          </Text>
          <div style={ModalInputDiv} className={'modalInputDiv'}>
            <input
              className={'overlay_input'}
              style={inputOverlayStyle}
              type={'text'}
              id={'clipBoardTrigger'}
              value={pageurl}
              readOnly={true}
            />
            <button
              href='#'
              id='clipBoardTrigger'
              className={clipBtnStyle}
              data-clipboard-target={'#clipBoardTrigger'}
              onClick={() => clickCopy()}
            >
              {i18n('label.copyButton')}
            </button>
          </div>
          <div className={'share'}>
            <SocialShare fptiInfo={fptiInfo} campaignInfo={campaignInfo} />
          </div>
        </div>
      );
    }
  };

  const confTitle = get(confirmationDetails, 'confirmationTitle');

  const confSubTitle = get(confirmationDetails, 'confirmationSubTitle');

  return (
    <Modal showOnMount={true} id={'campaignConfirmation'}>
      <>
        <div style={{ textAlign: 'center', marginBottom: '20px' }}>
          <img
            src='https://www.paypalobjects.com/webstatic/en_GB/mktg/ppc/icon-success.png'
            alt='confirmpng'
            height='82'
            width='82'
          />
        </div>
        <Text as='h2' size='xl3' className={styles['center-text']}>
          {confTitle ? confTitle : i18n('label.confirmation-title')}
        </Text>
        <Text
          as='p'
          size='md'
          className={`${styles['center-text']} ${styles['extra-margin']}`}
          dangerouslySetInnerHTML={{ __html: confSubTitle ? confSubTitle : i18n('label.confirmation-subTitle')}}
        >
        </Text>
        {renderSocialShare()}
      </>
    </Modal>
  );
};

export default ConfirmationPage;
